export default __webpack_public_path__ + "static/media/cymsa2_g.48065d14.jpg";